module.exports = __webpack_public_path__ + "img/mefly-logo-mobile.5a360e70.svg";